export class IdStatusDto {
    Id: number;
    Status: string;
}